import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { MaterialRequirementActions } from "redux/actions";

interface IMaterialRequirementState extends IBaseReducerState {}

const initialState: IMaterialRequirementState = {
  action: MaterialRequirementActions.prefix,
  prefix: MaterialRequirementActions.prefix,
};

const clearAction = (state: IMaterialRequirementState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.action = MaterialRequirementActions.prefix;
  });

const MaterialRequirementReducer =
  ReduxHelper.createHandleReducer<IMaterialRequirementState>(
    initialState,
    (builder) => {
      builder.addCase(
        MaterialRequirementActions.clearAction.request,
        clearAction
      );
    }
  );

export default MaterialRequirementReducer;
